module.exports = __webpack_public_path__ + "static/img/productLine_active.92484b5f.svg";